import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { cartMobx, discountMobx } from 'restaurant'
import { format } from '@dt/fe-utils'
import { forEach } from '@dt/fe-utils/dist/lodash'
import { TCalActivityType, TMarketingCate } from '@common/enum/mkt.enum'
import './index.scss'

interface IProps {
  /** 展示活动类型，目前先过滤配送费 */
  type?: string;
  reject?: () => void;
  resolve?: (product: any) => void;
}

const ActivityModal: React.FC<IProps> = (props) => {
  const [activityList, setActivityList] = useState([])
  const { type } = props
  const { cartResult } = cartMobx
  const { discountResult } = discountMobx

  const activityPrice = useMemo(() => {
    switch (type) {
      case TMarketingCate.ExpressFeeDiscount:
        return cartResult.discountExpressPrice
      default:
        return cartResult.activityPrice - cartResult.discountExpressPrice
    }
  }, [type])

  const setActivityItems = () => {
    const activityItemObj: any = {}
    // 单品优惠
    forEach(discountResult.itemMap, itemDiscount => itemDiscount.items && itemDiscount.items.forEach(item => {
      if ((type === TMarketingCate.ExpressFeeDiscount && item.calActivityType !== TCalActivityType.Express) || (!type && item.calActivityType === TCalActivityType.Express)) return
      if (['activity', 'ladderDiscount'].includes(item.offType)) {
        if (activityItemObj[item.offId]) {
          activityItemObj[item.offId].off += item.off
        } else {
          activityItemObj[item.offId] = { offTip: item.offTip, off: item.off, offId: item.offId }
        }
      }
    }))

    // 整单优惠
    discountResult.offArr.forEach(item => {
      if (['activity', 'ladderDiscount'].includes(item.offType)) {
        if (activityItemObj[item.offId]) {
          activityItemObj[item.offId].off += item.off
        } else {
          activityItemObj[item.offId] = { offTip: item.offTip, off: item.off, offId: item.offId }
        }
      }
    })
    setActivityList(Object.values(activityItemObj))
  }

  const ActivityItem = (item: any) => (
    <div className='am-item'>
      <div className='name'>{item.offTip}</div>
      <div className='used-discount'>-{format.toPrice(item.off)}</div>
    </div>
  )

  const handleClose = () => {
    props.reject()
  }

  useEffect(() => {
    setActivityItems()
  }, [])

  return (
    <IonModal
      cssClass='activity-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        <div className='am-title'>{i18n.t(`cart.${type ? 'discount' : 'discountActivity'}`)}</div>
      </IonHeader>
      <IonContent className='am-content'>
        <div className='am-list'>
          {
            activityList.map((itemDiscount: any) => {
              return <ActivityItem key={itemDiscount.offId} {...itemDiscount} />
            })
          }
        </div>
        <div className='am-result'>
          {i18n.t('cart.discountPriceTotal')} <span>-{format.toPrice(activityPrice)}</span>
        </div>
      </IonContent>
      <IonFooter className='am-footer'>
        <button className='default-btn' data-cypid='activityModalClose' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter>
    </IonModal>
  )
}

export default observer(ActivityModal)
